import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { Observable } from 'rxjs';
import { Opportunity } from '@vendasta/sales-opportunities';
import { OpportunityService } from '../../../../../../opportunity.service';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sales-ui-opportunity-name',
  imports: [CommonModule, GalaxyFormFieldModule, MatInputModule, TranslateModule, ReactiveFormsModule],
  templateUrl: './opportunity-name.component.html',
  styleUrls: ['../../opportunity-info-form.component.scss'],
})
export class OpportunityNameComponent {
  private opportunity$: Observable<Opportunity>;
  opportunityNameControl = new FormControl<string>('', Validators.required);

  constructor(
    private readonly updateService: OpportunityService,
    private readonly snackbarService: SnackbarService,
  ) {
    this.opportunity$ = this.updateService.currentOpportunity$;
    this.opportunity$.pipe(takeUntilDestroyed()).subscribe((opp) => {
      this.opportunityNameControl.setValue(opp.name, { emitEvent: false });
    });

    this.opportunityNameControl.valueChanges
      .pipe(
        takeUntilDestroyed(),
        distinctUntilChanged(),
        filter(() => this.opportunityNameControl.valid),
        debounceTime(500),
        switchMap((newName) => this.updateService.updateName(newName)),
      )
      .subscribe((newOpp) => {
        if (newOpp) {
          this.snackbarService.openSuccessSnack('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.NAME_UPDATED');
        } else {
          this.snackbarService.openErrorSnack('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.NAME_UPDATE_ERROR');
        }
        this.opportunityNameControl.updateValueAndValidity();
      });
  }
}
